import * as React from "react";

const ArrowIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 28 28"
  >
    <g clipPath="url(#clip0_5_113)">
      <path
        fill="var(--primary-foreground)"
        d="m26.868 13.897.463.463a.655.655 0 0 0 0-.926zm-3.706-3.706.463-.463a.655.655 0 0 0-1.12.463zm0 7.412h-.656a.655.655 0 0 0 1.119.463zm0-4.362H.926v1.312h22.236zm4.169.193-3.706-3.706-.927.926 3.706 3.706zm-4.825-3.243v7.412h1.312V10.19zm1.119 7.875 3.706-3.706-.927-.926-3.706 3.706z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_5_113">
        <path
          fill="var(--primary-foreground)"
          d="M27.794 13.897 13.897 27.794.001 13.897 13.897 0z"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

export default ArrowIcon;
